const install = (Vue, vm) => {
	uni.$u.http.setConfig((config) => {
	    config.baseURL = vm.$baseUrl;
		config.timeout = 60000;
	    return config;
	})
	
	let wxLogin = (params = {}) => vm.$u.http.get('web/account/wxLogin',{ params });	// 登录
	let wxAuthPhone = (data = {}) => vm.$u.http.post('web/account/wxAuthPhone', data);	// 授权手机号
	let getMemberInfo = (params = {}) => vm.$u.http.get('web/member/getMemberInfo',{ params });	// 获取个人信息
	let updateMember = (data = {}) => vm.$u.http.post('web/member/editMemberInfo', data);	// 更新个人信息
	let getBannerList = (params = {}) => vm.$u.http.get('web/config/getBannerList',{ params });	// 获取banner列表
	let getNearbyShopList = (data = {}) => vm.$u.http.post('web/shopInfo/nearby', data);	// 获取附近店铺列表
	let getShopDetail = (data = {}) => vm.$u.http.post('web/shopInfo/detail', data);	// 获取店铺详情
	let getCitySizeList = (params = {}) => vm.$u.http.get('web/config/getCitySizeList',{ params });	// 获取城市已开通物品尺寸
	let createOrder = (data = {}) => vm.$u.http.post('web/order/create', data);	// 创建订单
	let getCityByName = (params = {}) => vm.$u.http.get('web/config/getCityByName',{ params });	// 根据城市名称查询城市信息
	let getCategoryList = (params = {}) => vm.$u.http.get('web/config/getCategoryList',{ params });	// 获取物品分类列表
	let calculateLocalPrice = (data = {}) => vm.$u.http.post('web/config/calculateLocalPrice', data);	// 计算就地存取预估费用

	vm.$u.api = {
		wxLogin,
		wxAuthPhone,
		getMemberInfo,
		updateMember,
		getBannerList,
		getNearbyShopList,
		getShopDetail,
		getCitySizeList,
		createOrder,
		getCityByName,
		getCategoryList,
		calculateLocalPrice
	};
}

export default { install }